import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices/DomainServicesContext";
import { AuthZTuple } from "@/types";

export interface CollectionAccessData {
  relations: AuthZTuple[];
}

export function getAccessQueryKey(collectionId: string | undefined) {
  return ["collection", collectionId, "access"] as const;
}

export function useCollectionAccess(collectionId: string | undefined) {
  const { collections } = useDomainServices();

  return useQuery<CollectionAccessData, Error>({
    queryKey: getAccessQueryKey(collectionId),
    queryFn: ({ signal }) =>
      collections.getCollectionAccess(collectionId!, { abortSignal: signal }),
    enabled: Boolean(collectionId),
  });
}
